import { type SvgIconProps } from '@mui/material';

export const DisableSendIcon = (props: SvgIconProps) => (
    <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        sx={{ fontSize: 40 }}
        {...props}
    >
        <rect x="0.5" y="0.5" width="39" height="39" rx="3.5" fill="#F5F5F5" />
        <rect x="0.5" y="0.5" width="39" height="39" rx="3.5" stroke="#C7C7C7" />
        <path
            d="M31.709 8.28977C31.5741 8.15544 31.4036 8.06244 31.2176 8.0217C31.0315 7.98095 30.8378 7.99416 30.659 8.05977L8.65902 16.0598C8.46929 16.1317 8.30594 16.2597 8.19068 16.4267C8.07541 16.5937 8.01367 16.7918 8.01367 16.9948C8.01367 17.1977 8.07541 17.3958 8.19068 17.5628C8.30594 17.7298 8.46929 17.8578 8.65902 17.9298L18.259 21.7698L22.099 31.3698C22.1712 31.5512 22.2948 31.7075 22.4548 31.8194C22.6147 31.9314 22.8039 31.9941 22.999 31.9998C23.2011 31.9956 23.3972 31.9303 23.5614 31.8125C23.7257 31.6947 23.8503 31.5299 23.919 31.3398L31.919 9.33977C31.9872 9.16285 32.0036 8.9702 31.9664 8.78429C31.9292 8.59839 31.84 8.42688 31.709 8.28977ZM22.999 28.1998L20.209 21.1998L24.999 16.4098L23.589 14.9998L18.759 19.8298L11.799 16.9998L29.329 10.6698L22.999 28.1998Z"
            fill="#C7C7C7"
        />
    </svg>
);
